
import { AlertCircle } from "lucide-react";

interface ErrorMessageProps {
  message?: string;
  variant?: "warning" | "error";
}

const ErrorMessage = ({ 
  message = "This is taking longer than expected. There might be an issue with loading your data.",
  variant = "warning"
}: ErrorMessageProps) => {
  const colorClass = variant === "error" 
    ? "text-red-600 dark:text-red-400" 
    : "text-amber-600 dark:text-amber-400";
  
  return (
    <div className={`flex items-center justify-center gap-2 ${colorClass}`}>
      <AlertCircle size={20} />
      <p>{message}</p>
    </div>
  );
};

export default ErrorMessage;
